// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  profileId: __t.u64().primaryKey().name("profile_id"),
  band: __t.string(),
  envmapAssetId: __t.u64().name("envmap_asset_id"),
  sunColorHex: __t.string().name("sun_color_hex"),
  sunIntensity: __t.f32().name("sun_intensity"),
  sunElevationDeg: __t.f32().name("sun_elevation_deg"),
  ambientIntensity: __t.f32().name("ambient_intensity"),
});
